import $ from 'jquery';
const { registerBlockType } = wp.blocks;
const { InspectorControls, MediaUpload, MediaUploadCheck, RichText } =
  wp.blockEditor;
const { Button, Icon, PanelBody, SelectControl } = wp.components;
const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;
import clientSlider from '../../../resources/scripts/module/clients-slider';

const SLIDES_TO_SHOW = 2;

registerBlockType('pg/awards-slider', {
  title: 'PG Awards Slider',
  icon: 'images-alt2',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    logos: {
      type: 'array',
      default: [],
    },
    sectionClass: {
      type: 'string',
      default: 'section-light-secondary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-secondary',
    },
    optionalText: {
      type: 'string',
      default: '',
      source: 'html',
      selector: 'h3',
    },
  },

  edit: ({ attributes, setAttributes }) => {
    const {
      logos,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      optionalText,
    } = attributes;
    const [isAutoplay, setIsAutoplay] = useState(true);

    const convertedLogos = logos.map((logo) => {
      if (logo instanceof String) {
        return { url: logo, alt: '' };
      }

      return logo;
    });

    const toggleAutoplay = () => {
      const slider = $('[data-slider=clients]');
      if (slider.hasClass('slick-initialized')) {
        slider.slick('slickSetOption', 'autoplay', !isAutoplay, true);
      }
      setIsAutoplay(!isAutoplay);
    };

    const handleUpdateLogos = (newLogos) => {
      const slider = $('[data-slider=clients]');
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      setAttributes({ logos: newLogos });
    };

    useEffect(() => {
      clientSlider(isAutoplay);
    }, [logos, isAutoplay]);

    const onSelectLogos = (newLogos) => {
      handleUpdateLogos(
        newLogos.map((logo) => ({ url: logo.url, alt: logo.alt }))
      );
    };

    const onRemoveLogo = (removeIndex) => {
      const newLogos = logos.filter((_, index) => index !== removeIndex);
      handleUpdateLogos(newLogos);
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Slider Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={(value) => setAttributes({ sectionClass: value })}
            />
            <SelectControl
              label={__('Corner Position')}
              value={cornerPositionClass}
              options={[
                { label: 'None', value: 'corner-disabled' },
                { label: 'Left-Top', value: 'corner-left-top' },
                { label: 'Left-Bottom', value: 'corner-left-bottom' },
                { label: 'Right-Top', value: 'corner-right-top' },
                { label: 'Right-Bottom', value: 'corner-right-bottom' },
              ]}
              onChange={(value) =>
                setAttributes({ cornerPositionClass: value })
              }
            />
            <SelectControl
              label={__('Corner Background')}
              value={cornerBackgroundClass}
              options={[
                { label: 'Dark Primary', value: 'corner-on-dark-primary' },
                { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
                { label: 'Light Primary', value: 'corner-on-light-primary' },
                {
                  label: 'Light Secondary',
                  value: 'corner-on-light-secondary',
                },
              ]}
              onChange={(value) =>
                setAttributes({ cornerBackgroundClass: value })
              }
            />
          </PanelBody>
        </InspectorControls>
        <div className="client-logos-editor">
          <MediaUploadCheck>
            <MediaUpload
              onSelect={onSelectLogos}
              allowedTypes={['image']}
              multiple
              gallery
              render={({ open }) => (
                <Button onClick={open} isPrimary>
                  Add Award Logos
                </Button>
              )}
            />
          </MediaUploadCheck>
          <Button isSecondary onClick={toggleAutoplay}>
            {isAutoplay ? 'Stop Autoplay' : 'Start Autoplay'}
          </Button>
          <section className={sectionClass}>
            <div
              className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
            ></div>
            <div className="scroll-list-wrapper">
              <RichText
                tagName="h3"
                className="optional-text"
                value={optionalText}
                onChange={(value) => setAttributes({ optionalText: value })}
                placeholder={__('Add your text here...')}
              />
              <div className="awards-carousel-slider">
                <div
                  data-slider="clients"
                  data-slides-to-show={SLIDES_TO_SHOW}
                  className="awards-carousel-slider-items"
                >
                  {convertedLogos.map((logo, index) => (
                    <div key={index} className="awards-carousel-slider-item">
                      <img
                        src={logo.url}
                        alt={logo.alt ?? `Logo ${index + 1}`}
                      />
                      <button
                        onClick={() => onRemoveLogo(index)}
                        className="remove-logo-button"
                        aria-label="Remove logo"
                      >
                        <span className="remove-icon">×</span>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const {
      logos,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      optionalText,
    } = attributes;
    const convertedLogos = logos.map((logo) => {
      if (logo instanceof String) {
        return { url: logo, alt: '' };
      }

      return logo;
    });

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
        ></div>
        <div className="scroll-list-wrapper">
          {optionalText && (
            <RichText.Content
              tagName="h3"
              className="optional-text"
              value={optionalText}
            />
          )}
          <div className="awards-carousel-slider">
            <div
              data-slider="clients"
              data-slides-to-show={SLIDES_TO_SHOW}
              className="awards-carousel-slider-items"
            >
              {convertedLogos.map((logo, index) => (
                <img
                  className="awards-carousel-slider-item"
                  key={index}
                  src={logo.url}
                  alt={logo.alt ?? `Logo ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  },
});
